"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationApi = exports.NotificationApiFactory = exports.NotificationApiFp = exports.NotificationApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * NotificationApi - axios parameter creator
 * @export
 */
const NotificationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Confirm email communication opt-in
         * @param {string} userId User ID
         * @param {NotificationConfirmConsentRequest} [notificationConfirmConsentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailCommunicationOptIn: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, notificationConfirmConsentRequest, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('confirmEmailCommunicationOptIn', 'userId', userId);
            const localVarPath = `/v1/notifications/users/{user_id}/email-notifications/consent`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}/email-notifications/consent`,
                sdkMethod: 'confirmEmailCommunicationOptIn',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationConfirmConsentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics event
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventRequest} [analyticsCreateAnalyticsEventRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAnalyticsEvent: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, rHGApp, analyticsCreateAnalyticsEventRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvent', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvent', 'userId', userId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvent', 'rHGApp', rHGApp);
            const localVarPath = `/v1/analytics/users/{user_id}/action`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/analytics/users/{user_id}/action`,
                sdkMethod: 'createAnalyticsEvent',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analyticsCreateAnalyticsEventRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics events
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventsRequest} [analyticsCreateAnalyticsEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsEvents: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rHGApp, analyticsCreateAnalyticsEventsRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvents', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvents', 'recipientId', recipientId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsEvents', 'rHGApp', rHGApp);
            const localVarPath = `/v1/analytics/recipients/{recipient_id}/actions`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/analytics/recipients/{recipient_id}/actions`,
                sdkMethod: 'createAnalyticsEvents',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analyticsCreateAnalyticsEventsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Emit a new streaming analytics events. This endpoint is used to emit events that are not stored in the database. The events are emitted to the streaming analytics system. Event name should be in snake_case. Event name will be used as the event type in the streaming analytics system.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsStreamEventsRequest} [analyticsCreateAnalyticsStreamEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsStreamEvents: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rHGApp, analyticsCreateAnalyticsStreamEventsRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsStreamEvents', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsStreamEvents', 'recipientId', recipientId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('createAnalyticsStreamEvents', 'rHGApp', rHGApp);
            const localVarPath = `/v1/analytics/recipients/{recipient_id}/stream/events`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/analytics/recipients/{recipient_id}/stream/events`,
                sdkMethod: 'createAnalyticsStreamEvents',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analyticsCreateAnalyticsStreamEventsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create new user
         * @param {string} userId User ID
         * @param {NotificationCreateUserRequest} [notificationCreateUserRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createNotificationUser: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, notificationCreateUserRequest, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('createNotificationUser', 'userId', userId);
            const localVarPath = `/v1/notifications/users/{user_id}`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}`,
                sdkMethod: 'createNotificationUser',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationCreateUserRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create new user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {NotificationCreateUserRequest} [notificationCreateUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationUserV2: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, notificationCreateUserRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createNotificationUserV2', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('createNotificationUserV2', 'userId', userId);
            const localVarPath = `/v2/notifications/users/{user_id}`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/notifications/users/{user_id}`,
                sdkMethod: 'createNotificationUserV2',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationCreateUserRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Deletes device information.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} deviceId Device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, deviceId }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('deleteDevice', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('deleteDevice', 'userId', userId);
            // verify required parameter 'deviceId' is not null or undefined
            (0, common_1.assertParamExists)('deleteDevice', 'deviceId', deviceId);
            const localVarPath = `/v1/notifications/users/{user_id}/devices/{device_id}`
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)))
                .replace(`{${'device_id'}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}/devices/{device_id}`,
                sdkMethod: 'deleteDevice',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes notifications by recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationsByRecipient: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('deleteNotificationsByRecipient', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deleteNotificationsByRecipient', 'recipientId', recipientId);
            const localVarPath = `/v2/notifications/recipients/{recipient_id}/notifications`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/notifications/recipients/{recipient_id}/notifications`,
                sdkMethod: 'deleteNotificationsByRecipient',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Deletes user and all associated notifications and devices
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('deleteUser', 'userId', userId);
            const localVarPath = `/v1/notifications/users/{user_id}`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}`,
                sdkMethod: 'deleteUser',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | e |
         * @summary Deletes notifications by recipient permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeNotificationsByRecipient: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('expungeNotificationsByRecipient', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('expungeNotificationsByRecipient', 'recipientId', recipientId);
            const localVarPath = `/v2/notifications/recipients/{recipient_id}/notifications/expunge`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/notifications/recipients/{recipient_id}/notifications/expunge`,
                sdkMethod: 'expungeNotificationsByRecipient',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Fetch notifications scheduled for the recipient Circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientNotifications: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientNotifications', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientNotifications', 'recipientId', recipientId);
            const localVarPath = `/v2/notifications/recipients/{recipient_id}/notifications`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/notifications/recipients/{recipient_id}/notifications`,
                sdkMethod: 'getRecipientNotifications',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch user and associated information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUser', 'userId', userId);
            const localVarPath = `/v1/notifications/users/{user_id}`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}`,
                sdkMethod: 'getUser',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserCommunicationPreference: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getUserCommunicationPreference', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserCommunicationPreference', 'userId', userId);
            const localVarPath = `/v1/notifications/users/{user_id}/preferences`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}/preferences`,
                sdkMethod: 'getUserCommunicationPreference',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCommunicationPreferenceV2: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getUserCommunicationPreferenceV2', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserCommunicationPreferenceV2', 'userId', userId);
            const localVarPath = `/v2/notifications/users/{user_id}/preferences`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/notifications/users/{user_id}/preferences`,
                sdkMethod: 'getUserCommunicationPreferenceV2',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch notifications scheduled for the user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotifications: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserNotifications', 'userId', userId);
            const localVarPath = `/v1/notifications/users/{user_id}/notifications`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}/notifications`,
                sdkMethod: 'getUserNotifications',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Handles circle events from Pub/Sub. Requires google service account bearer auth token.
         * @param {NotificationPubsubPushRequest} notificationPubsubPushRequest Pubsub push request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleCirclePubSubMessage: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ notificationPubsubPushRequest }, options = {}) {
            // verify required parameter 'notificationPubsubPushRequest' is not null or undefined
            (0, common_1.assertParamExists)('handleCirclePubSubMessage', 'notificationPubsubPushRequest', notificationPubsubPushRequest);
            const localVarPath = `/v1/notifications/pubsub/circle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/pubsub/circle`,
                sdkMethod: 'handleCirclePubSubMessage',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationPubsubPushRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch users information
         * @param {Array<string>} [userIds] List of user ids, NOTE - This should NOT be a comma separated list!
         * @param {string} [externalUserId] External User ID, that used to identify the user in the external system. E.g. Iterable.
         * @param {string} [limit] The number of results to return, leave out for all
         * @param {string} [offset] The offset of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userIds, externalUserId, limit, offset }, options = {}) {
            const localVarPath = `/v1/notifications/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userIds) {
                localVarQueryParameter['user_ids'] = userIds;
            }
            if (externalUserId !== undefined) {
                localVarQueryParameter['external_user_id'] = externalUserId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users`,
                sdkMethod: 'searchUsersV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Generic endpoint that sends an email on demand. This endpoint requires no circle level permissions. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sends an email notification to user.
         * @param {string} userId User ID
         * @param {'user-extraction'} emailNotificationType Email notification type.
         * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE Request to send email notification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailNotification: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, emailNotificationType, uNKNOWNBASETYPE, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('sendEmailNotification', 'userId', userId);
            // verify required parameter 'emailNotificationType' is not null or undefined
            (0, common_1.assertParamExists)('sendEmailNotification', 'emailNotificationType', emailNotificationType);
            // verify required parameter 'uNKNOWNBASETYPE' is not null or undefined
            (0, common_1.assertParamExists)('sendEmailNotification', 'uNKNOWNBASETYPE', uNKNOWNBASETYPE);
            const localVarPath = `/v1/notifications/users/{user_id}/email-notifications/{email_notification_type}/send`
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)))
                .replace(`{${'email_notification_type'}}`, encodeURIComponent(String(emailNotificationType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}/email-notifications/{email_notification_type}/send`,
                sdkMethod: 'sendEmailNotification',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(uNKNOWNBASETYPE, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint is hit by Google Pub/Sub and requires google service account bearer auth token. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sends a push notification to user.
         * @param {NotificationPubsubPushRequest} notificationPubsubPushRequest Pubsub push request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ notificationPubsubPushRequest }, options = {}) {
            // verify required parameter 'notificationPubsubPushRequest' is not null or undefined
            (0, common_1.assertParamExists)('sendNotification', 'notificationPubsubPushRequest', notificationPubsubPushRequest);
            const localVarPath = `/v1/notifications/pubsub/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/pubsub/send`,
                sdkMethod: 'sendNotification',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationPubsubPushRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Registers user device information. This endpoint is used to register a new device or update an existing device. Note: This endpoint should be called only after user is being created. If user is not created yet, this endpoint will return 404.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} deviceId Device ID
         * @param {NotificationSyncDeviceRequest} notificationSyncDeviceRequest Sync device request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDevice: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, deviceId, notificationSyncDeviceRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('syncDevice', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('syncDevice', 'userId', userId);
            // verify required parameter 'deviceId' is not null or undefined
            (0, common_1.assertParamExists)('syncDevice', 'deviceId', deviceId);
            // verify required parameter 'notificationSyncDeviceRequest' is not null or undefined
            (0, common_1.assertParamExists)('syncDevice', 'notificationSyncDeviceRequest', notificationSyncDeviceRequest);
            const localVarPath = `/v1/notifications/users/{user_id}/devices/{device_id}`
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)))
                .replace(`{${'device_id'}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}/devices/{device_id}`,
                sdkMethod: 'syncDevice',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationSyncDeviceRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Updates a user
         * @param {string} userId User ID
         * @param {NotificationUpdateUserRequest} [notificationUpdateUserRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateUser: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, notificationUpdateUserRequest }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('updateUser', 'userId', userId);
            const localVarPath = `/v1/notifications/users/{user_id}`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}`,
                sdkMethod: 'updateUser',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationUpdateUserRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Updates a user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {NotificationUpdateUserRequestV2} [notificationUpdateUserRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserV2: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, notificationUpdateUserRequestV2, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('updateUserV2', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('updateUserV2', 'userId', userId);
            const localVarPath = `/v2/notifications/users/{user_id}`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/notifications/users/{user_id}`,
                sdkMethod: 'updateUserV2',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationUpdateUserRequestV2, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upserts communication preferences. If the preference is an email preference and the user is required to consent to email communication and has not, an error will be returned. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  Communication Channels, types, and delivery methods: | Name                            | Type          | Email | Push | |---------------------------------|---------------|-------|------| | **personalized_recommendation** | **channel**   |   ✓   | ✓    | | clinical_program_recommendation | message_type  |   ✓   | ✓    | | condition_recommendation        | message_type  |   ✓   | ✓    | | mental_health_screening         | message_type  |   ✓   | ✓    | | **tips_and_suggestion**         | **channel**   |   ✓   | ✓    | | re_engagement                   | message_type  |   ✓   | ✓    | | winback                         | message_type  |   ✓   | ✓    | | **updates**                     | **channel**   |   ✓   | ✓    | | app_update                      | message_type  |   ✓   | ✓    | | new_program                     | message_type  |   ✓   | ✓    | | newsletter                      | message_type  |   ✓   | ✓    |
         * @summary Upsert communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {Array<NotificationUserCommunicationPreference>} notificationUserCommunicationPreference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertUserCommunicationPreference: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, notificationUserCommunicationPreference, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('upsertUserCommunicationPreference', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('upsertUserCommunicationPreference', 'userId', userId);
            // verify required parameter 'notificationUserCommunicationPreference' is not null or undefined
            (0, common_1.assertParamExists)('upsertUserCommunicationPreference', 'notificationUserCommunicationPreference', notificationUserCommunicationPreference);
            const localVarPath = `/v1/notifications/users/{user_id}/preferences`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/users/{user_id}/preferences`,
                sdkMethod: 'upsertUserCommunicationPreference',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationUserCommunicationPreference, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Unauthenticated endpoint that is called by Iterable for status update. The signature in the body are used to validate if the request is valid. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Webhook for Iterable to call Calm with status update.
         * @param {NotificationWebhookIterableCallback} notificationWebhookIterableCallback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookIterableStatusUpdate: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ notificationWebhookIterableCallback, }, options = {}) {
            // verify required parameter 'notificationWebhookIterableCallback' is not null or undefined
            (0, common_1.assertParamExists)('webhookIterableStatusUpdate', 'notificationWebhookIterableCallback', notificationWebhookIterableCallback);
            const localVarPath = `/v1/notifications/webhooks/iterable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/webhooks/iterable`,
                sdkMethod: 'webhookIterableStatusUpdate',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationWebhookIterableCallback, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.NotificationApiAxiosParamCreator = NotificationApiAxiosParamCreator;
/**
 * NotificationApi - functional programming interface
 * @export
 */
const NotificationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.NotificationApiAxiosParamCreator)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Confirm email communication opt-in
         * @param {string} userId User ID
         * @param {NotificationConfirmConsentRequest} [notificationConfirmConsentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailCommunicationOptIn(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmEmailCommunicationOptIn(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics event
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventRequest} [analyticsCreateAnalyticsEventRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAnalyticsEvent(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAnalyticsEvent(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics events
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventsRequest} [analyticsCreateAnalyticsEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsEvents(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAnalyticsEvents(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Emit a new streaming analytics events. This endpoint is used to emit events that are not stored in the database. The events are emitted to the streaming analytics system. Event name should be in snake_case. Event name will be used as the event type in the streaming analytics system.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsStreamEventsRequest} [analyticsCreateAnalyticsStreamEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsStreamEvents(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAnalyticsStreamEvents(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create new user
         * @param {string} userId User ID
         * @param {NotificationCreateUserRequest} [notificationCreateUserRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createNotificationUser(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createNotificationUser(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create new user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {NotificationCreateUserRequest} [notificationCreateUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationUserV2(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createNotificationUserV2(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Deletes device information.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} deviceId Device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDevice(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes notifications by recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationsByRecipient(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteNotificationsByRecipient(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Deletes user and all associated notifications and devices
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUser(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | e |
         * @summary Deletes notifications by recipient permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeNotificationsByRecipient(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expungeNotificationsByRecipient(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Fetch notifications scheduled for the recipient Circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientNotifications(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecipientNotifications(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch user and associated information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUser(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserCommunicationPreference(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserCommunicationPreference(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCommunicationPreferenceV2(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserCommunicationPreferenceV2(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch notifications scheduled for the user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotifications(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserNotifications(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Handles circle events from Pub/Sub. Requires google service account bearer auth token.
         * @param {NotificationPubsubPushRequest} notificationPubsubPushRequest Pubsub push request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleCirclePubSubMessage(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.handleCirclePubSubMessage(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch users information
         * @param {Array<string>} [userIds] List of user ids, NOTE - This should NOT be a comma separated list!
         * @param {string} [externalUserId] External User ID, that used to identify the user in the external system. E.g. Iterable.
         * @param {string} [limit] The number of results to return, leave out for all
         * @param {string} [offset] The offset of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchUsersV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Generic endpoint that sends an email on demand. This endpoint requires no circle level permissions. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sends an email notification to user.
         * @param {string} userId User ID
         * @param {'user-extraction'} emailNotificationType Email notification type.
         * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE Request to send email notification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailNotification(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendEmailNotification(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint is hit by Google Pub/Sub and requires google service account bearer auth token. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sends a push notification to user.
         * @param {NotificationPubsubPushRequest} notificationPubsubPushRequest Pubsub push request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendNotification(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Registers user device information. This endpoint is used to register a new device or update an existing device. Note: This endpoint should be called only after user is being created. If user is not created yet, this endpoint will return 404.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} deviceId Device ID
         * @param {NotificationSyncDeviceRequest} notificationSyncDeviceRequest Sync device request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDevice(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncDevice(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Updates a user
         * @param {string} userId User ID
         * @param {NotificationUpdateUserRequest} [notificationUpdateUserRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateUser(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUser(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Updates a user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {NotificationUpdateUserRequestV2} [notificationUpdateUserRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserV2(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserV2(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Upserts communication preferences. If the preference is an email preference and the user is required to consent to email communication and has not, an error will be returned. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  Communication Channels, types, and delivery methods: | Name                            | Type          | Email | Push | |---------------------------------|---------------|-------|------| | **personalized_recommendation** | **channel**   |   ✓   | ✓    | | clinical_program_recommendation | message_type  |   ✓   | ✓    | | condition_recommendation        | message_type  |   ✓   | ✓    | | mental_health_screening         | message_type  |   ✓   | ✓    | | **tips_and_suggestion**         | **channel**   |   ✓   | ✓    | | re_engagement                   | message_type  |   ✓   | ✓    | | winback                         | message_type  |   ✓   | ✓    | | **updates**                     | **channel**   |   ✓   | ✓    | | app_update                      | message_type  |   ✓   | ✓    | | new_program                     | message_type  |   ✓   | ✓    | | newsletter                      | message_type  |   ✓   | ✓    |
         * @summary Upsert communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {Array<NotificationUserCommunicationPreference>} notificationUserCommunicationPreference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertUserCommunicationPreference(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertUserCommunicationPreference(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Unauthenticated endpoint that is called by Iterable for status update. The signature in the body are used to validate if the request is valid. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Webhook for Iterable to call Calm with status update.
         * @param {NotificationWebhookIterableCallback} notificationWebhookIterableCallback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookIterableStatusUpdate(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webhookIterableStatusUpdate(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.NotificationApiFp = NotificationApiFp;
/**
 * NotificationApi - factory interface
 * @export
 */
const NotificationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.NotificationApiFp)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Confirm email communication opt-in
         * @param {string} userId User ID
         * @param {NotificationConfirmConsentRequest} [notificationConfirmConsentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailCommunicationOptIn(params, options) {
            return localVarFp
                .confirmEmailCommunicationOptIn(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics event
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventRequest} [analyticsCreateAnalyticsEventRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAnalyticsEvent(params, options) {
            return localVarFp
                .createAnalyticsEvent(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Create a new analytics events
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsEventsRequest} [analyticsCreateAnalyticsEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsEvents(params, options) {
            return localVarFp
                .createAnalyticsEvents(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Emit a new streaming analytics events. This endpoint is used to emit events that are not stored in the database. The events are emitted to the streaming analytics system. Event name should be in snake_case. Event name will be used as the event type in the streaming analytics system.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AnalyticsCreateAnalyticsStreamEventsRequest} [analyticsCreateAnalyticsStreamEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalyticsStreamEvents(params, options) {
            return localVarFp
                .createAnalyticsStreamEvents(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create new user
         * @param {string} userId User ID
         * @param {NotificationCreateUserRequest} [notificationCreateUserRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createNotificationUser(params, options) {
            return localVarFp
                .createNotificationUser(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create new user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {NotificationCreateUserRequest} [notificationCreateUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationUserV2(params, options) {
            return localVarFp
                .createNotificationUserV2(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Deletes device information.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} deviceId Device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice(params, options) {
            return localVarFp
                .deleteDevice(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes notifications by recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationsByRecipient(params, options) {
            return localVarFp
                .deleteNotificationsByRecipient(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Deletes user and all associated notifications and devices
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(params, options) {
            return localVarFp
                .deleteUser(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | e |
         * @summary Deletes notifications by recipient permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeNotificationsByRecipient(params, options) {
            return localVarFp
                .expungeNotificationsByRecipient(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Fetch notifications scheduled for the recipient Circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientNotifications(params, options) {
            return localVarFp
                .getRecipientNotifications(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch user and associated information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(params, options) {
            return localVarFp
                .getUser(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserCommunicationPreference(params, options) {
            return localVarFp
                .getUserCommunicationPreference(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCommunicationPreferenceV2(params, options) {
            return localVarFp
                .getUserCommunicationPreferenceV2(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch notifications scheduled for the user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotifications(params, options) {
            return localVarFp
                .getUserNotifications(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Handles circle events from Pub/Sub. Requires google service account bearer auth token.
         * @param {NotificationPubsubPushRequest} notificationPubsubPushRequest Pubsub push request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleCirclePubSubMessage(params, options) {
            return localVarFp
                .handleCirclePubSubMessage(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Fetch users information
         * @param {Array<string>} [userIds] List of user ids, NOTE - This should NOT be a comma separated list!
         * @param {string} [externalUserId] External User ID, that used to identify the user in the external system. E.g. Iterable.
         * @param {string} [limit] The number of results to return, leave out for all
         * @param {string} [offset] The offset of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersV1(params, options) {
            return localVarFp
                .searchUsersV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Generic endpoint that sends an email on demand. This endpoint requires no circle level permissions. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sends an email notification to user.
         * @param {string} userId User ID
         * @param {'user-extraction'} emailNotificationType Email notification type.
         * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE Request to send email notification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailNotification(params, options) {
            return localVarFp
                .sendEmailNotification(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is hit by Google Pub/Sub and requires google service account bearer auth token. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sends a push notification to user.
         * @param {NotificationPubsubPushRequest} notificationPubsubPushRequest Pubsub push request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification(params, options) {
            return localVarFp
                .sendNotification(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Registers user device information. This endpoint is used to register a new device or update an existing device. Note: This endpoint should be called only after user is being created. If user is not created yet, this endpoint will return 404.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} deviceId Device ID
         * @param {NotificationSyncDeviceRequest} notificationSyncDeviceRequest Sync device request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDevice(params, options) {
            return localVarFp
                .syncDevice(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Updates a user
         * @param {string} userId User ID
         * @param {NotificationUpdateUserRequest} [notificationUpdateUserRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateUser(params, options) {
            return localVarFp
                .updateUser(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Updates a user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {NotificationUpdateUserRequestV2} [notificationUpdateUserRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserV2(params, options) {
            return localVarFp
                .updateUserV2(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Upserts communication preferences. If the preference is an email preference and the user is required to consent to email communication and has not, an error will be returned. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  Communication Channels, types, and delivery methods: | Name                            | Type          | Email | Push | |---------------------------------|---------------|-------|------| | **personalized_recommendation** | **channel**   |   ✓   | ✓    | | clinical_program_recommendation | message_type  |   ✓   | ✓    | | condition_recommendation        | message_type  |   ✓   | ✓    | | mental_health_screening         | message_type  |   ✓   | ✓    | | **tips_and_suggestion**         | **channel**   |   ✓   | ✓    | | re_engagement                   | message_type  |   ✓   | ✓    | | winback                         | message_type  |   ✓   | ✓    | | **updates**                     | **channel**   |   ✓   | ✓    | | app_update                      | message_type  |   ✓   | ✓    | | new_program                     | message_type  |   ✓   | ✓    | | newsletter                      | message_type  |   ✓   | ✓    |
         * @summary Upsert communication preferences for the user
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} userId User ID
         * @param {Array<NotificationUserCommunicationPreference>} notificationUserCommunicationPreference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertUserCommunicationPreference(params, options) {
            return localVarFp
                .upsertUserCommunicationPreference(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Unauthenticated endpoint that is called by Iterable for status update. The signature in the body are used to validate if the request is valid. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Webhook for Iterable to call Calm with status update.
         * @param {NotificationWebhookIterableCallback} notificationWebhookIterableCallback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookIterableStatusUpdate(params, options) {
            return localVarFp
                .webhookIterableStatusUpdate(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.NotificationApiFactory = NotificationApiFactory;
/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
class NotificationApi extends base_1.BaseAPI {
    /**
     * URL `/v1/notifications/users/{user_id}/email-notifications/consent`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Confirm email communication opt-in
     * @param {string} userId User ID
     * @param {NotificationConfirmConsentRequest} [notificationConfirmConsentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    confirmEmailCommunicationOptIn(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .confirmEmailCommunicationOptIn(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/analytics/users/{user_id}/action`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Create a new analytics event
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {AnalyticsCreateAnalyticsEventRequest} [analyticsCreateAnalyticsEventRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    createAnalyticsEvent(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .createAnalyticsEvent(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/analytics/recipients/{recipient_id}/actions`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Create a new analytics events
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {AnalyticsCreateAnalyticsEventsRequest} [analyticsCreateAnalyticsEventsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    createAnalyticsEvents(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .createAnalyticsEvents(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/analytics/recipients/{recipient_id}/stream/events`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Emit a new streaming analytics events. This endpoint is used to emit events that are not stored in the database. The events are emitted to the streaming analytics system. Event name should be in snake_case. Event name will be used as the event type in the streaming analytics system.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {AnalyticsCreateAnalyticsStreamEventsRequest} [analyticsCreateAnalyticsStreamEventsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    createAnalyticsStreamEvents(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .createAnalyticsStreamEvents(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Create new user
     * @param {string} userId User ID
     * @param {NotificationCreateUserRequest} [notificationCreateUserRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    createNotificationUser(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .createNotificationUser(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/notifications/users/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Create new user
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {NotificationCreateUserRequest} [notificationCreateUserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    createNotificationUserV2(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .createNotificationUserV2(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}/devices/{device_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Deletes device information.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {string} deviceId Device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    deleteDevice(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .deleteDevice(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/notifications/recipients/{recipient_id}/notifications`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
     * @summary Deletes notifications by recipient.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    deleteNotificationsByRecipient(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .deleteNotificationsByRecipient(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Deletes user and all associated notifications and devices
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    deleteUser(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .deleteUser(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/notifications/recipients/{recipient_id}/notifications/expunge`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | e |
     * @summary Deletes notifications by recipient permanently.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    expungeNotificationsByRecipient(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .expungeNotificationsByRecipient(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/notifications/recipients/{recipient_id}/notifications`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Fetch notifications scheduled for the recipient Circle
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    getRecipientNotifications(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .getRecipientNotifications(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Fetch user and associated information
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    getUser(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .getUser(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}/preferences`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Get communication preferences for the user
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    getUserCommunicationPreference(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .getUserCommunicationPreference(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/notifications/users/{user_id}/preferences`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Get communication preferences for the user
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    getUserCommunicationPreferenceV2(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .getUserCommunicationPreferenceV2(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}/notifications`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Fetch notifications scheduled for the user
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    getUserNotifications(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .getUserNotifications(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/pubsub/circle`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Handles circle events from Pub/Sub. Requires google service account bearer auth token.
     * @param {NotificationPubsubPushRequest} notificationPubsubPushRequest Pubsub push request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    handleCirclePubSubMessage(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .handleCirclePubSubMessage(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Fetch users information
     * @param {Array<string>} [userIds] List of user ids, NOTE - This should NOT be a comma separated list!
     * @param {string} [externalUserId] External User ID, that used to identify the user in the external system. E.g. Iterable.
     * @param {string} [limit] The number of results to return, leave out for all
     * @param {string} [offset] The offset of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    searchUsersV1(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .searchUsersV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}/email-notifications/{email_notification_type}/send`
     * Generic endpoint that sends an email on demand. This endpoint requires no circle level permissions. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Sends an email notification to user.
     * @param {string} userId User ID
     * @param {'user-extraction'} emailNotificationType Email notification type.
     * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE Request to send email notification.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    sendEmailNotification(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .sendEmailNotification(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/pubsub/send`
     * This endpoint is hit by Google Pub/Sub and requires google service account bearer auth token. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Sends a push notification to user.
     * @param {NotificationPubsubPushRequest} notificationPubsubPushRequest Pubsub push request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    sendNotification(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .sendNotification(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}/devices/{device_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Registers user device information. This endpoint is used to register a new device or update an existing device. Note: This endpoint should be called only after user is being created. If user is not created yet, this endpoint will return 404.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {string} deviceId Device ID
     * @param {NotificationSyncDeviceRequest} notificationSyncDeviceRequest Sync device request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    syncDevice(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .syncDevice(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Updates a user
     * @param {string} userId User ID
     * @param {NotificationUpdateUserRequest} [notificationUpdateUserRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    updateUser(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .updateUser(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/notifications/users/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Updates a user
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {NotificationUpdateUserRequestV2} [notificationUpdateUserRequestV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    updateUserV2(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .updateUserV2(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/users/{user_id}/preferences`
     * Upserts communication preferences. If the preference is an email preference and the user is required to consent to email communication and has not, an error will be returned. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  Communication Channels, types, and delivery methods: | Name                            | Type          | Email | Push | |---------------------------------|---------------|-------|------| | **personalized_recommendation** | **channel**   |   ✓   | ✓    | | clinical_program_recommendation | message_type  |   ✓   | ✓    | | condition_recommendation        | message_type  |   ✓   | ✓    | | mental_health_screening         | message_type  |   ✓   | ✓    | | **tips_and_suggestion**         | **channel**   |   ✓   | ✓    | | re_engagement                   | message_type  |   ✓   | ✓    | | winback                         | message_type  |   ✓   | ✓    | | **updates**                     | **channel**   |   ✓   | ✓    | | app_update                      | message_type  |   ✓   | ✓    | | new_program                     | message_type  |   ✓   | ✓    | | newsletter                      | message_type  |   ✓   | ✓    |
     * @summary Upsert communication preferences for the user
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} userId User ID
     * @param {Array<NotificationUserCommunicationPreference>} notificationUserCommunicationPreference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    upsertUserCommunicationPreference(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .upsertUserCommunicationPreference(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/webhooks/iterable`
     * Unauthenticated endpoint that is called by Iterable for status update. The signature in the body are used to validate if the request is valid. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Webhook for Iterable to call Calm with status update.
     * @param {NotificationWebhookIterableCallback} notificationWebhookIterableCallback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    webhookIterableStatusUpdate(params, options) {
        return (0, exports.NotificationApiFp)(this.configuration)
            .webhookIterableStatusUpdate(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.NotificationApi = NotificationApi;
//# sourceMappingURL=notification-api.js.map